document.addEventListener('alpine:init', () => {
  Alpine.data('ctrFaqs', (config) => ({
    sectionId: config.sectionId,
    openItems: [0],

    get allowMultiple() {
      return this.$el.dataset.allowMultiple === 'true';
    },

    init() {
      this.$nextTick(() => {
        this.setupShopifyEvents();
      });
    },

    isOpen(index) {
      return this.openItems.includes(index);
    },

    toggle(index) {
      if (this.isOpen(index)) {
        this.openItems = this.openItems.filter(i => i !== index);
      } else {
        if (this.allowMultiple) {
          this.openItems = [...this.openItems, index];
        } else {
          this.openItems = [index];
        }
      }
    },

    setupShopifyEvents() {
      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:section:load', (event) => {
          if (event.detail.sectionId === this.sectionId) {
            this.openItems = [0];
          }
        });

        document.addEventListener('shopify:block:select', (event) => {
          if (event.detail.sectionId === this.sectionId) {
            const blockElement = event.target;
            const faqItem = blockElement.closest('.ctr-faqs__item');
            if (faqItem) {
              const items = Array.from(faqItem.parentElement.children);
              const index = items.indexOf(faqItem);
              if (index !== -1 && !this.isOpen(index)) {
                if (this.allowMultiple) {
                  this.openItems = [...this.openItems, index];
                } else {
                  this.openItems = [index];
                }
              }
            }
          }
        });
      }
    }
  }));
});
